import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    AppBar,
    Toolbar,
    Box,
    Menu,
    MenuItem,
    Button,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const Header = ({ open, onSelectionChange }) => {
    const location = useLocation();
    const isLVCCPage = location.pathname === "/lvcc";
    const isVitrosPage = location.pathname === "/vitros";

    const [anchorElCalculation, setAnchorElCalculation] = useState(null);
    const [anchorElModel, setAnchorElModel] = useState(null);

    const [calculation, setCalculation] = useState("");  // What is selected in Calculation
    const [model, setModel] = useState("");              // What is selected in Model

    const modelOptions = {
        "Response":     ["End Point", "Two Point", "N Point", "ImmunoRate", "Dual Wavelength", "DW Blank", "Potentiometric"],
        "Calibration":  ["End Point", "Two Point", "N Point", "ImmunoRate", "Dual Wavelength", "Dual Wavelength (MS)", "DW Blank", "Potentiometric"],
        "Prediction":   ["End Point", "Two Point", "N Point", "ImmunoRate", "Dual Wavelength", "DW Blank", "Potentiometric"],
        "Utility": ["Spline Interpolate"]
    };

    useEffect(() => {
        // Reset model selection if calculation changes
        setModel("");
    }, [calculation]);

    // Notify parent (App.js) when either value changes
    useEffect(() => {
        onSelectionChange({ calculation, model });
    }, [calculation, model]);

    const handleCalculationSelect = (value) => {
        setCalculation(value);
        setAnchorElCalculation(null);
    };

    const handleModelSelect = (value) => {
        setModel(value);
        setAnchorElModel(null);
    };

    return (
        <AppBar
            position="sticky"
            sx={{
                top: 0,
                backgroundColor: "white",
                color: "black",
                boxShadow: "none",
                zIndex: 1100,
                paddingLeft: open ? "250px" : "80px",
                borderBottom: '1px solid lightgrey'
            }}
        >
            <Toolbar
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 1,
                }}
            >
                {(isLVCCPage || isVitrosPage) && (
                    <>
                        <Button
                            variant="outlined"
                            sx={{
                                fontWeight: "bold",
                                fontSize: '18px',
                                borderRadius: 0,
                                textTransform: "none",
                                borderColor: "white",
                                color: "black",
                            }}
                        >
                            {location.pathname} {/* TODO: Put a more user-friendly title on the page */}
                        </Button>

                        <Box sx={{ border: "1px solid lightgrey", display: "flex", alignItems: "center" }}>
                            {/* Calculation Dropdown */}
                            <Button
                                onClick={(e) => setAnchorElCalculation(e.currentTarget)}
                                endIcon={<ArrowDropDownIcon />}
                                sx={{
                                    fontStyle: "italic",
                                    textTransform: "none",
                                    color: "black",
                                    fontSize: '18px',
                                    pl: 5,
                                    pr: 5,
                                    fontWeight: calculation ? "bold" : "normal"
                                }}
                            >
                                {calculation || "Calculation"}
                            </Button>
                            <Menu
                                anchorEl={anchorElCalculation}
                                open={Boolean(anchorElCalculation)}
                                onClose={() => setAnchorElCalculation(null)}
                            >
                                {Object.keys(modelOptions).map(option => (
                                    <MenuItem
                                        key={option}
                                        onClick={() => handleCalculationSelect(option)}
                                        selected={calculation === option}
                                    >
                                        {option}
                                    </MenuItem>
                                ))}
                            </Menu>

                            <KeyboardArrowRightIcon />

                            {/* Model Dropdown */}
                            <Button
                                onClick={(e) => setAnchorElModel(e.currentTarget)}
                                endIcon={<ArrowDropDownIcon />}
                                disabled={!calculation}
                                sx={{
                                    fontStyle: "italic",
                                    textTransform: "none",
                                    color: "black",
                                    fontSize: '18px',
                                    pl: 5,
                                    pr: 5,
                                    fontWeight: model ? "bold" : "normal"
                                }}
                            >
                                {model || "Model"}
                            </Button>
                            <Menu
                                anchorEl={anchorElModel}
                                open={Boolean(anchorElModel)}
                                onClose={() => setAnchorElModel(null)}
                            >
                                {modelOptions[calculation]?.map(option => (
                                    <MenuItem
                                        key={option}
                                        onClick={() => handleModelSelect(option)}
                                        selected={model === option}
                                    >
                                        {option}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Header;